/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareEntity } from '../fw/MetaDataHelper.ts';

export default declareEntity({
    entity: "eventListenerStates",
    graphQL: "EventListenerState",
    name: "Event Listener State",
    dynamoPrefix: 'sys',
    storageType: 'silo',
    userEditable: false,
    fields: (types) => { return {
        id: {
            name: "Event Listener State ID",
            type: "id",
            id: true,
            defaultValue: () => {
                return uuidv4();
            },
            required: true,
            primaryKey: true,
        },
        channel: {
            name: "Application",
            type: "relation",
            to: () => types['channels'],
            required: true,
            defaultValue: (channel) => {
                return channel['id'];
            },
        },
        organisation: {
            name: "Organisation",
            type: "relation",
            to: () => types['organisations'],
            defaultValue: (channel) => {
                return channel['organisation_id'];
            },
            required: true
        },
        instance: {
            name: "Instance",
            type: "relation",
            to: () => types['instances'],
            userEditable: false,
            hiddenCreate: true,
            defaultValue: (parent) => {
                if (parent) {
                    return parent['instance_id'];
                }
            },
        },
        listener: {
            name: "Listener",
            type: "string",
            defaultValue: "",
        },
        eventState: {
            name: "Event State",
            type: "object",
            defaultValue: {},
            userEditable: false,
        },
        dependsOnListener: {
            name: "Depends On Listener",
            type: "relation",
            to: () => types['eventListenerStates'],
            required: true,
        },
        listenerVersion: {
            name: "Listener version",
            type: "int",
            defaultValue: 1,
            userEditable: false,
        },
    }; }
});
